import React from 'react';
import { motion, type Variants } from 'framer-motion';
import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import * as S from './Colour.style';
import {
    COLOR_FRAME_WOODSTAIN,
    COLOUR_FRAME,
} from '@modules/paint-picker-new/config';
import type { RGB } from '@modules/paint-picker-new/type';

interface ColourProps {
    rgb: RGB;
    isWoodstain?: boolean;
}

export const Colour = ({ rgb, isWoodstain = false }: ColourProps) => {
    const { desktop } = useAppDisplayModeContext();
    const { css } = useStyles({
        rgb,
        frame: isWoodstain ? COLOR_FRAME_WOODSTAIN : COLOUR_FRAME,
    });

    return (
        <motion.div
            variants={desktop ? (S.colourAnimation as Variants) : undefined}
            className={css(S.Container)}
        >
            <div className={css(S.Colour)} />
        </motion.div>
    );
};
